import { Divider, Heading, Tag, TagLabel } from "@chakra-ui/react";
import clsx from "clsx";
import { format } from "date-fns";
import { Pin, ShieldCheck } from "lucide-react";
import React from "react";
import { PortfolioWorkHistoryItem } from "../../types";
import { Rating } from "./rating";
import { ExpandableText } from "features/jobs/expandable-text";

interface WorkHistoryItemProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  item: PortfolioWorkHistoryItem;
  editable?: boolean;
  pinned?: boolean;
  canPin?: boolean;

  onPinToggle?: () => void;

  isLoading?: boolean;
}

export function WorkHistoryItem({
  item,
  className,
  pinned,
}: WorkHistoryItemProps) {
  const { name, description, endedAt, clientReview, verified, id } = item;

  return (
    <>
      <div
        className={clsx(" grid grid-cols-[1fr,32px] border-b py-4", className)}
      >
        <div className={clsx("flex flex-col gap-4 ")}>
          <div className="flex flex-col gap-2 items-start">
            {pinned && (
              <Tag
                size="lg"
                display="flex"
                alignItems="center"
                borderRadius="full"
                colorScheme="flatteredFlamingo"
              >
                <Pin className="w-4 mr-2 rotate-45 fill-flatteredFlamingo-600" />
                <TagLabel fontWeight="500">Pinned</TagLabel>
              </Tag>
            )}
            <div className="flex flex-col lg:flex-row items-start lg:items-center  gap-1">
              <Heading as="h4" fontSize={18} className="font-medium m-0">
                {name}
              </Heading>

              {verified && (
                <div className="flex  items-center gap-1">
                  <ShieldCheck className="fill-flatteredFlamingo-500 stroke-white" />
                  <p>Verified</p>
                </div>
              )}
            </div>

            <div className="flex flex-col lg:flex-row gap-1 lg:gap-4">
              {clientReview && (
                <>
                  <div className="flex items-center gap-1">
                    <Rating size="sm" rating={clientReview.rating} />
                    <p>{clientReview.rating.toFixed(2)}</p>
                  </div>

                  <Divider orientation="vertical" />
                </>
              )}
              <p>{format(new Date(endedAt), "MMM dd, yyyy")}</p>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            {description !== name && <ExpandableText text={description} />}
            {clientReview?.feedback && (
              <blockquote className="text-sm text-gray-500">
                <q>{clientReview?.feedback}</q>
              </blockquote>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
